import path from "path"
import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"

export default (props) => {
  const { name } = props
  const gql = useStaticQuery(graphql`
    query {
      partials: allMdx(filter: { fileAbsolutePath: { glob: "**/content/partials/*.mdx" } }) {
        nodes {
          fileAbsolutePath
          body
        }
      }
    }
  `)

  const item = gql.partials.nodes.find((p) => path.basename(p.fileAbsolutePath, ".mdx") === name)
  if (!item) console.warn("Partial not found:", name)

  return item ? <MDXRenderer {...props}>{item.body}</MDXRenderer> : null
}
